export default "/assets/images/critter-cuddler-small.20eb80ce8f58df19.png";